import { render } from "./SetEmailSubscription.vue?vue&type=template&id=b7d2a23c"
import script from "./SetEmailSubscription.vue?vue&type=script&lang=js"
export * from "./SetEmailSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__